/* eslint-disable import/no-extraneous-dependencies */

import Admin from 'hive-admin';

// import getFilterWithCol from '../../../helpers/getFilterWithCol';
import { sizeSimpleChoices } from '../helpers';

// import Types from '../../../common/modules/types';

const isNotLetterSpacing = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'LETTER_SPACING',
]);

const isNotLetterSpacingSizeCustom = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'letter_spacing_size',
  '!==',
  'CUSTOM',
]);

export default [
  ...[
    ['FieldRadio', {
      label: null,
      name: 'letter_spacing_size',
      initialValue: 'MEDIUM',
      block: true,
      choices: [
        ...sizeSimpleChoices,
        {
          label: 'Custom',
          value: 'CUSTOM',
        },
      ],
    }],
    ['FieldText', {
      label: null,
      name: 'letter_spacing_sizeCustom',
      prefix: 'Size:',
      skip: [isNotLetterSpacingSizeCustom],
    }],
  ].map(([fieldType, fieldConfig]) => Admin.compileFromLibrary([
    fieldType,
    {
      ...fieldConfig,
      preSkip: [isNotLetterSpacing, ...(fieldConfig.preSkip || [])],
    },
  ])),
];
